import { Box, SxProps } from "@mui/material";

import { FIELDWORKER_COLORS } from "~/config/statusColors";

import { fieldworkerLoadingAnimation } from "./fieldworker-loading-animation";
import { ICON_FIELDWORKER_VARIANTS, IconFieldworkerVariant } from "./iconFieldworkerVariants";

export type IconFieldworkerProps = {
    isAssigned?: boolean;
    variant: IconFieldworkerVariant;
    loading?: boolean;
    sx?: SxProps;
};

export function IconFieldworker({ isAssigned = false, variant, loading, sx }: IconFieldworkerProps) {
    return (
        <Box
            sx={{
                borderRadius: "100%",
                backgroundColor: isAssigned ? FIELDWORKER_COLORS.assigned : FIELDWORKER_COLORS.available,
                animation: loading ? fieldworkerLoadingAnimation : null,
                ...sx,
            }}
        >
            <img
                alt={`Fieldworker ${variant} icon`}
                style={{ display: "block" }}
                src={ICON_FIELDWORKER_VARIANTS[variant]}
            />
        </Box>
    );
}
